<template>
  <div>
    <el-form ref="formData" size="small" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_optionName') || '备选项名称'"
            prop="optionName"
          >
            <el-input
              v-model="formData.optionName"
              :placeholder="
                $l('INDEX.form_label_pe_optionName') || '请输入备选项名称'
              "
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_optionNameEn') || '备选项英文名称'"
            prop="optionNameEn"
          >
            <el-input
              v-model="formData.optionNameEn"
              :placeholder="
                $l('INDEX.form_label_pe_optionNameEn') || '请输入备选项英文名称'
              "
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.form_label_optionFullName') || '备选项完整显示文字'
            "
            prop="optionFullName"
          >
            <el-input
              v-model="formData.optionFullName"
              :placeholder="
                $l('INDEX.form_label_pe_optionFullName') ||
                  '请输入备选项完整显示文字'
              "
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.form_label_optionFullNameEn') ||
                '备选项完整显示文字英文'
            "
            prop="optionFullNameEn"
          >
            <el-input
              v-model="formData.optionFullNameEn"
              :placeholder="
                $l('INDEX.form_label_pe_optionFullNameEn') ||
                  '请输入备选项完整显示文字英文'
              "
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        optionName: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_pe_optionName') || '请输入备选项名称',
            trigger: 'blur',
          },
        ],
        optionNameEn: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_pe_optionNameEn') ||
              '请输入备选项英文名称',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
              if (!reg.test(value)) {
                callback()
              } else {
                callback(
                  new Error(
                    this.$l('form_placeholder_optionNameEn_noChina') ||
                      '英文名称不能存在中文'
                  )
                )
              }
            },
          },
        ],
        optionFullName: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_pe_optionFullName') ||
              '请输入备选项完整显示文字',
            trigger: 'blur',
          },
        ],
        optionFullNameEn: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_pe_optionFullNameEn') ||
              '请输入备选项完整显示文字英文',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
              if (!reg.test(value)) {
                callback()
              } else {
                callback(
                  new Error(
                    this.$l('form_placeholder_optionFullNameEn_noChina') ||
                      '英文名称不能存在中文'
                  )
                )
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const params = {
        metadataType: 'Content',
        upOptionCode: '0',
        optionLevel: 1,
        optionStatus: 'Y',
        ...this.formData,
      }
      const res = await this.$api
        .sampleMetadataOptionsSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || res.msg,
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
      this.backDialogVisible = false
    },
  },
}
</script>
